const regex = /^[a-z]{4,5}:\/{2}[^/]+(?::[0-9]+)?(\/.*)/gi;

export const removeHost = (input: string): string => input.replace(regex, '$1');
